<template>
  <div  class="is-flex is-flex-direction-row">
    <div  v-for="(item, i) in source.items" 
          :key="item.id" 
          class="vs-card">
      <card :key="i"
            :item="item"
            :is-widget="isWidget"
            :data-int="dataInt"
            @click="select"
            @navToWidget="navToWidgetContent">
        <template #header>
          <a  v-if="openInNewTab"
              :href="item.path"
              class="is-small"
              style="position: absolute; top: 0; right: 0; z-index: 2;"
              target="_blank">
            <bulma-icon icon-class="fas fa-external-link-alt"/>
          </a>
        </template> 
      </card>
    </div>
  </div>
</template>

<script setup lang="ts">
import { inject } from "vue"

import Card from "./Card.vue"
import BulmaIcon from "@/components/common/BulmaIcon.vue"

type Props = {
  index: number,
  // Items should be limited to a maximum of 4
  source: { items: any[]},
  isWidget: boolean,
  dataInt?: string,
  openInNewTab?: boolean
}
defineProps<Props>()

//@ts-ignore
const { navToWidgetContent, select } = inject("eventHandlers")
</script>
<style scoped lang="scss">
  .vs-card {
    width: 25%;
    padding: 0.75rem;
    @media screen and (max-width: 768px) {
      min-width: 8em;
    }
  }
</style>